import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './css/App.css';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });
const store = configureStore(history);

  ReactDOM.render(

    <Provider store={store}>
        <ConnectedRouter history={history}>
        <div className="App"> 
                <App /> 
        </div>
            
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  );

registerServiceWorker();

